/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface UpdateAccountProxyLink$Request {
    accountId: number;
    proxyLink?: string;
}

export interface UpdateAccountProxyLink$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountProxyLinkRequest = createAction<PayloadData<void, UpdateAccountProxyLink$Request>>('UPDATE_ACCOUNT_PROXY_LINK__UPDATE_ACCOUNT_PROXY_LINK__REQUEST');
export const updateAccountProxyLinkSuccess = createAction<PayloadData<void, UpdateAccountProxyLink$Request>>('UPDATE_ACCOUNT_PROXY_LINK__UPDATE_ACCOUNT_PROXY_LINK__SUCCESS');
export const updateAccountProxyLinkFailure = createAction<PayloadData<Error, UpdateAccountProxyLink$Request, true>>('UPDATE_ACCOUNT_PROXY_LINK__UPDATE_ACCOUNT_PROXY_LINK__FAILURE');

export const updateAccountProxyLinkActions = [
    updateAccountProxyLinkRequest,
    updateAccountProxyLinkSuccess,
    updateAccountProxyLinkFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} [meta.proxyLink]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountProxyLink = (meta: UpdateAccountProxyLink$Request, config?: UpdateAccountProxyLink$Config) => {
    const TRANSPORT_GET_PARAMS = {
        proxyLink: meta.proxyLink,
    };
    return {
        CALL_API: {
            types: updateAccountProxyLinkActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/proxies`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

